import React from 'react';

const CustomPackageOption = (props: any): any => {
  const {
    packageCost,
    name,
  } = props;
  return (
    <React.Fragment>
      <span className="selected-package">
        {name}
      </span>
      <span className="bold">
        ₹ {packageCost}
      </span>
    </React.Fragment>
  );
};

export default CustomPackageOption;
